import { useState } from "react";
import { Play } from "lucide-react";

export default function VideoEmbed({ videoId, title, subtitle, testId }) {
    const [playing, setPlaying] = useState(false);
    const [thumbSrc, setThumbSrc] = useState(`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`);

    return (
        <div
            data-testid={testId || `video-embed-${videoId}`}
            className="relative w-full aspect-video bg-charcoal-2 overflow-hidden group"
        >
            {!playing ? (
                <button
                    data-testid={`${testId || `video-embed-${videoId}`}-play`}
                    onClick={() => setPlaying(true)}
                    className="absolute inset-0 w-full h-full text-left"
                    aria-label={`Play ${title}`}
                >
                    <img
                        src={thumbSrc}
                        alt={title}
                        loading="lazy"
                        onError={() => setThumbSrc(`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`)}
                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/30" />
                    <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-gold text-charcoal flex items-center justify-center play-pulse">
                            <Play size={32} fill="currentColor" />
                        </div>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10">
                        {subtitle && <p className="overline mb-2">{subtitle}</p>}
                        <h3 className="font-display text-2xl md:text-4xl text-cream max-w-xl leading-tight">
                            {title}
                        </h3>
                        <p className="mt-3 text-sm text-[#C9A84C] tracking-wider uppercase font-medium">
                            Watch Full Walkthrough →
                        </p>
                    </div>
                </button>
            ) : (
                <iframe
                    title={title}
                    src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
                    className="absolute inset-0 w-full h-full"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            )}
        </div>
    );
}
